export const CRITERIA_STATUS = {
  QUALIFYING_TRIGGER: 'qualifying_trigger',
  DISQUALIFIED_TRIGGER: 'disqualified_trigger',
  LEGACY_TRIGGER: 'legacy_trigger',
  NON_QUALIFYING: 'non_qualifying'
}

export const CRITERIA_STATUS_FILTER_ALL = 'all'

export const UNDER_ASSESSMENT_FILTER = {
  ALL: 'all',
  UNDER: 'under',
  NOT_UNDER: 'not_under'
}

export const TAXONOMIC_GROUP_FILTER_ALL = 'all'

export const SORTABLE_COLUMNS = [
  'taxonomicGroup',
  'scientificName',
  'commonName',
  'siteBest',
  'minReproductiveUnits',
  'globallySensitive',
  'criteriaStatus'
]

export const DEFAULT_SORT = {
  sortBy: 'taxonomicGroup',
  sortDirection: 'ASC',
  secondarySortBy: 'scientificName',
  secondarySortDirection: 'ASC'
}

export const SEARCH_DEBOUNCE_MS = 275
